<template>
  <div>

              <div class="row py-4">

                  <div class="col-12 col-md-12">


                      <FORM  action="https://felderer.de/elbridge/accept/?supplier=Helios" method="post" name="productsubmit" enctype="multipart/form-data" target="_parent" class="w-100">
                          <INPUT type="hidden" id="version" name="version"  value=""/>
                          <INPUT type="hidden" id="result" name="result" value="" />
                          <a class="btn btn-primary border-0"  @click.prevent="sendToFelderer">
                              <svg class="icon icon-sm">
                                  <use xlink:href="/assets/img/icon-sprite.svg#global.in-cart-alternative"
                                       xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                              </svg><span class="align-middle">{{ __('lang.shoppingcart.pricecalculation') }}</span>
                          </a>
                      </FORM>
                  </div>
<!--                  <div class="col-12">
                      <span v-if="product_data.state && product_data.state.toLowerCase() == 'v'"
                          class="small text-primary">{{ __('lang.product.text.old') }}</span>
                      <span v-else class="mr-3">
                          <span class="font-weight-bold">{{ __('lang.global.price') }}:</span>
                          <span v-if="!user.auth">{{ __('lang.message.loginrequired') }}</span>
                          <span v-else-if="this.user.countries_price == ''">{{ this.__('lang.global.onrequest') }}</span>&lt;!&ndash;  +' PreisLand unbekannt' &ndash;&gt;
                          &lt;!&ndash; <span v-else-if="this.user.countries_price != this.selectedlocale.country || this.user.countries_price != this.user.countries_iso">{{ this.__('lang.global.onrequest') }}</span> &ndash;&gt;  &lt;!&ndash; + ' fremdes Land' &ndash;&gt;
                          <span v-else-if="this.user.countries_price != this.selectedlocale.country">{{ this.__('lang.global.onrequest') }}</span>
                          <span v-else-if="parseFloat(product_data.price) > 0">{{ product_data.price }}</span>
                          <span v-else>{{ __('lang.global.onrequest') }}</span>
                      </span>
                  </div>-->
              </div>

    <div class="row mb-3">
      <div class="col-12">
        <p class="text-gray-80 border-bottom small">{{ __('lang.short.ref_no')}}: {{product_data.ref_no}} -
          {{product_data.version}}</p>
      </div>



        <div v-show="product_data.description_long && product_data.description_long.trim().length != 0" class="col-12 col-md-7">
          <div id="product_description" class="col-12 col-md-8 mb-3 mb-md-0 preview collapsed collapse" >
            <span style="white-space: pre-line">
            <h3 class="text-gray-50 mb-4">{{ __('lang.global.product.properties') }}</h3>
            <p>{{ product_data.description_long }}</p>
            </span>
          </div>
          <p v-show="product_data.description_long &&  product_data.description_long.trim().length != 0" class="small mt-3 text-center">
    							<a :class="'preview_hs collapsed ' + dynamicCSSContent" id="more" ref="more" aria-expanded="false" data-toggle="collapse" href="#product_description" role="button" aria-controls="product_description" > <!-- :style="dynamicCSSContent" -->
    								<span class="text" >show more</span><span class="text-primary d-block">
    									<svg class="icon"><use xlink:href="/assets/img/icon-sprite.svg#global.collapse" xmlns:xlink="http://www.w3.org/1999/xlink"></use></svg>
    								</span>
    							</a>
          </p>
        </div>
<!--techdata exist always-->
<!--      <div v-if="product_media.filter(item => item.f_download==1 && item.media_type!= 'image' && item.filename!='').length>0"-->
        <div class="col-12 col-md-4">
        <h3 class="text-gray-50 mb-4">{{ __('lang.global.product.downloads_quicklinks')}}</h3>
        <ul class="list-unstyled downloads">
            <li class="mb-1">
                <a class="text-primary font-weight-bold"  role="button" @click.prevent="createPdf">
                    <svg class="icon">
                        <use xlink:href="/assets/img/icon-sprite.svg#global.file.pdf"
                             xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                    </svg>
                    {{__('lang.output.pdf.techdatasheet.header')}}
                    <span
                        class="d-block small font-weight-light text-secondary ml-1">PDF</span>
                </a>
          </li>
          <li class="mb-1"
            v-for="(media, mediaIndex) in product_media.filter(item => item.f_download==1 && item.path!='' && item.filename!='' && item.media_type!= 'image' && item.media_type!= 'vdi' && item.media_type!= 'revit' )">
            <a class="text-primary font-weight-bold" role="button" target="_blank"
              :href="mediaserver_url + media.path + media.filename">
              <svg class="icon" v-if="media.media_type==='lvtext'">
                <use xlink:href="/assets/img/icon-sprite.svg#global.file.txt"
                  xmlns:xlink="http://www.w3.org/1999/xlink"></use>
              </svg>
              <svg class="icon" v-else-if="media.media_type==='threedmodel'">
                <use xlink:href="/assets/img/icon-sprite.svg#global.file.3d" xmlns:xlink="http://www.w3.org/1999/xlink">
                </use>
              </svg>
              <svg class="icon" v-else>
                <use xlink:href="/assets/img/icon-sprite.svg#global.file.pdf"
                  xmlns:xlink="http://www.w3.org/1999/xlink"></use>
              </svg>
              {{ __('lang.global.product.downloads.'+ media.media_type)}}
              <span
                class="d-block small font-weight-light text-secondary ml-1">{{media.filename.substring(media.filename.lastIndexOf(".")+1).toUpperCase()}}</span>
            </a>
          </li>
          <li class="mb-1"
            v-for="(media, mediaIndex) in product_media.filter(item => item.f_download==1 && item.filename != '' && item.media_type!= 'image' && (item.media_type==='vdi' || item.media_type=== 'revit') )">
            <a class="text-primary font-weight-bold" :href="media.filename" target="_blank">
              <svg class="icon">
                <use xlink:href="/assets/img/icon-sprite.svg#global.external-link"
                  xmlns:xlink="http://www.w3.org/1999/xlink"></use>
              </svg>
              {{ __('lang.global.product.downloads.'+ media.media_type)}}
            </a>
          </li>

            <li class="mt-2">
                <a class="text-primary font-weight-bold" role="button"  @click.prevent="createZip">
                    <svg class="icon">
                        <use xlink:href="/assets/img/icon-sprite.svg#global.file.zip"
                             xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                    </svg>
                    {{__('lang.global.product.downloads_zip')}}
                    <span
                        class="d-block small font-weight-light text-secondary ml-1">ZIP</span>
                </a>
            </li>

        </ul>
       <!--  <p class="small w-75 d-none d-md-block">{{__('lang.downloads.extendedtext')}} <a id="downloads-nav-tab"
            data-toggle="tab" href="#downloads-tab-pane" role="tab" aria-controls="downloads-tab-pane"
            aria-selected="false" @click.prevent="setDownloadTabactive">{{ __('lang.global.product.downloads')}}</a>.
        </p> -->
<!--          <p><a class="btn btn-primary btn-block border-0" href="#" @click.prevent="createZip">
              <svg class="icon">
                  <use xlink:href="/assets/img/icon-sprite.svg#global.form.send" xmlns:xlink="http://www.w3.org/1999/xlink">
                  </use>
              </svg>{{__('lang.global.product.downloads_zip')}}</a></p>-->
          <p class="small w-75 d-none d-md-block">{{ __('lang.downloads.extendedtext') }} {{ __('lang.global.product.downloads') }}.</p>




      </div>
    </div>
  </div>
</template>

<script>

    import axios from "./services/api/axiosConfig";

    export default {
        computed: {
            product_data:{
                get () {
                  return this.$store.state.productdata.product_data
                },
            },
            product_media:{
              get(){
                return this.$store.state.productdata.product_media
              }
            },
            product_data_extended:{
                get () {
                    return this.$store.state.productdata
                },
            },



            /*
            mediatyplist: function () {
              //ToDo sort by ???
              var mediasorted = this.product_data.product_media.sort((a, b) => a.media_type.localeCompare(b.media_type));
              var media_type = mediasorted.map(function(o){return o.media_type}).filter(function(v,i,a) {
                  return a.indexOf(v)===i
                });
              console.log('Start  media_type');
              console.log( media_type);
              console.log('End  media_type');
              return media_type
            },
            */
            selectedAccessories: {
            get() {
              return this.$store.state.shoppingcart.selectedAccessories
            },
          },
          selectedFans: {
            get() {
              return this.$store.state.shoppingcart.selectedFans
            },
          },

          accessories: {
            get() {
              return this.$store.state.productdata.accessories
            },
            set(value) {
              this.$store.commit('productdata/setAccessories', value);

            }
          },
          /*  media_dir : {
            get () {
                return this.$store.state.productdata.media_dir
            },
          }, */
          session: {
            get() {
              return this.$store.state.user.session
            },
            set(value) {
              this.$store.commit('user/updateSession', value)
            }
          },
          user: {
            get() {
              return this.$store.state.user.user
            },
            set(value) {
              this.$store.commit('user/updateUser', value)
            }
          },
          selectedlocale: {
            get() {
              return this.$store.state.user.selectedlocale
            },
            set(value) {
              this.$store.commit('user/updateSelectedlocale', value)
            }
        },

        dynamicCSSContent() {
            var desc = this.product_data.description_long
            //if(desc.trim().length === 0) return 'preview_hs'
            var lang = !this.$lang().locale ? 'de' : this.$lang().locale

            return 'preview_hs_'+ lang


            /*return `content: "${this.__('lang.global.product.description.show_more')}"`;


               return `
                  [data - toggle="collapse"].preview_hs.text::after {

                    visibility: visible;
                    position: absolute;
                    width: 100 %;
                    left: 0;
                    content: "${this.__('lang.global.product.description.show_more')}";

                  }

                  [data - toggle="collapse"].preview_hs.text {
                    visibility: hidden;
                    width: 100 %;
                    position: relative;
                    display: inline - block;
                  }

                  [data - toggle="collapse"].preview_hs: not(.collapsed) .text:: after {
                      content: "${this.__('lang.global.product.description.show_less')}";
                    } `;
               */

        },
        /*
        dynamicComputedProperty() {
          // Use the result of the method in your computed property
          return this.accessRefMore();
        },*/

        },
        data() {
          return {
            mediaserver_url: '',//'https://globalstest.heliosventilatoren.de' ,
            Project: {},
            Articles: [],
            countries: '{"DEU": "DE","AUT": "AT","FRA": "FR","___":"__"}',
          }
        },
        methods : {
          setDownloadTabactive:function(){
            this.$parent.$refs.productdetail.isActive=true  // for ProductDetailTab :aria-selected="isActive" is set but for working not enough
         },
            createObjectStructure(){
                this.createArticleStructure();
                this.createProjectStructure();

                this.Project.Articles = this.Articles;


            },
            createProjectStructure() {
                this.Project = {
                  language_id: this.$lang().locale,

                }
            },
            createArticleStructure() {

                var ArticleList = '';
                var version = '';
                var artNo = ''

                this.Articles = []
                var op={}
                var op_is={}
                var op_must={}
                var opdata=this.product_data_extended.op
                console.log('OPDATA:')
                console.log(opdata)

                Object.assign(op_is, {
                    airflowrate: opdata.op_volumeflow,
                    externalpressure: opdata.op_pressure,
                    wsoll: opdata.op_angle,
                    electricity: opdata.op_electricity,
                    elpower: opdata.op_elpower,
                    rpm: opdata.op_rpm,
                    sfp:opdata.op_sfp
                });

                Object.assign(op_must, {
                    airflowrate: opdata.airflow,
                    externalpressure: opdata.pressure,
                    airflow_unit: opdata.airflowunits,
                    externalpressure_unit: opdata.pressureunits,
                    externalpressuretyp: opdata.pressuretype,
                    airflowrate_dev: opdata.airflow_deviation,
                    externalpressure_dev: opdata.pressure_deviation,
                    maxdba: opdata.maxdba,
                    airflowrate_is:opdata.op_volumeflow,
                    externalpressure_is:opdata.op_pressure,
                    wsoll_is:opdata.op_angle

                });
                Object.assign(op, { op_must: op_must, op_is: op_is  })

                this.Articles.push({
                        Article: {
                            artNo: this.product_data.ref_no,
                            version: this.product_data.version,
                            execution: this.product_data.execution ??0,
                            name: this.product_data.type,
                            language_id: this.$lang().locale, //navigator.language,
                            productSource: 1,
                            flagFan: this.product_data.flag_fan,
                            op: op
                        }
                    });

                console.log('createArticleStructure:')
                console.log(this.Articles)
            },
            /*Zip:*/
            createZip() {
                document.getElementsByTagName("body")[0].classList.add("is-loading");
                this.createObjectStructure()
                // Make an API request to Laravel to create the ZIP file
                axios.post('/create/zip', { project: this.Project , fileIds: [1, 2, 3] }, {responseType: "blob"})
                    .then(response => {
                        // Handle the response, e.g., show a success message or download the ZIP
                        document.getElementsByTagName("body")[0].classList.remove("is-loading");
                        var fileURL = window.URL.createObjectURL(new Blob([response.data]), {type:'application/zip'});
                        var link = document.createElement('a');
                        link.href = fileURL;
                        link.setAttribute('download', 'HeliosSelect.zip');
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        console.log('create zip')
                    })
                    .catch(error => {
                        // Handle errors
                        console.log('create zip failed')
                    });
            },
            /*:Zip*/
            /*PDF:*/
            createPdf() {
                document.getElementsByTagName("body")[0].classList.add("is-loading");
                this.createObjectStructure()
                // Make an API request to Laravel to create the XML/PDF file
                axios.post('/create/productxml',{ project: this.Project },{ headers: { 'Content-Type': 'application/json',  'Accept': 'application/pdf' }, responseType: "blob" } )
                    .then(response => {
                        document.getElementsByTagName("body")[0].classList.remove("is-loading");
                        const blob = new Blob([response.data], { type: 'application/pdf' })
                        const link = document.createElement('a')
                        link.href = URL.createObjectURL(blob)
                        link.download = 'HeliosSelectProduct.pdf'
                        link.click()
                        URL.revokeObjectURL(link.href)
                    }).catch(console.error)
            },

            /*:PDF*/
            createFeldererJson() {
                var list = [];
                var cartitem = {};
                var product = this.product_data



                cartitem = {
                        MANUFACTURER_PID: product.ref_no,
                        MANUFACTURER_TYPE_DESC: product.type,
                        DESCRIPTION_SHORT: product.description_short,
                        QUANTITY: 1,
                        ORDER_UNIT: "ST",
                        SUPPLIER_ID_GLN: "4010184000006",

                }
                list.push(cartitem);
                var strJson = JSON.stringify (list);
                console.log(strJson)
                return (strJson);
            },
            async logoutAndSubmit(l,c) {
                try {
                    axios.post('/'+c+'-'+l, {version:'1.0',language:l,country:c.toUpperCase() })
                        .then(response => {
                            // Handle the response, e.g., show a success message or download the ZIP

                            console.log('logoutAndSubmit axios.post')
                        })
                        .catch(error => {
                            // Handle errors
                            console.log('logoutAndSubmit axios.post failed')
                        });

                    document.productsubmit.submit();
                } catch (error) {
                    console.log("Logout failed:", error);
                }
            },
            sendToFelderer() {
                var strJson=this.createFeldererJson();
                var result =[];
                result.push(strJson);

                document.getElementById('version').value='1.0'
                document.getElementById('result').value=result;

                console.log('productdetail sendToFelderer selectedlocale:',this.selectedlocale)
                const context = { test: 'de' };
                //this.logoutAndSubmit.call({ session: this.session });
                this.logoutAndSubmit.call({ },this.selectedlocale.language,this.convertCountryIsoAlphas(this.selectedlocale.country,2));

            },
            convertCountryIsoAlphas(code, alpha) {
                const allcountries = JSON.parse(this.countries);
                const defaultCode = {"DEU": "DE"}

                for (const [code3, code2] of Object.entries(allcountries)) {
                    if (code2.toUpperCase() === code.toUpperCase()) {
                        return alpha === 3 ? code3.toLowerCase() : code2.toLowerCase();
                    } else if (code3.toUpperCase() === code.toUpperCase()) {
                        return alpha === 3 ? code3.toLowerCase() : code2.toLowerCase();
                    }
                }

                if (alpha === 3) {
                    return Object.keys(defaultCode)[0].toLowerCase();
                } else {
                    return Object.values(defaultCode)[0].toLowerCase();
                }

                //return code.toLowerCase();
            },



        },
        mounted() {
           /* console.log('DETAILDESC:');
            console.log(this.$root.$refs);*/
        }

    }


</script>



<style>

[data-toggle="collapse"].preview_hs .text::after {

    visibility: visible;
    position: absolute;
    width: 100%;
    left: 0;
    content: ''

}

[data-toggle="collapse"].preview_hs .text {
  visibility: hidden;
  width: 100%;
  position: relative;
  display: inline-block;
}

[data-toggle="collapse"].preview_hs:not(.collapsed) .text::after {
  content:''
}


[data-toggle="collapse"].preview_hs_de .text::after {

    visibility: visible;
    position: absolute;
    width: 100%;
    left: 0;
    content: 'Mehr anzeigen'
}
[data-toggle="collapse"].preview_hs_de .text {
  visibility: hidden;
  width: 100%;
  position: relative;
  display: inline-block;
}

[data-toggle="collapse"].preview_hs_de:not(.collapsed) .text::after {
  content:'Weniger anzeigen'
}


[data-toggle="collapse"].preview_hs_en .text::after {
    visibility: visible;
    position: absolute;
    width: 100%;
    left: 0;
    content: 'Show more'
}
[data-toggle="collapse"].preview_hs_en .text {
  visibility: hidden;
  width: 100%;
  position: relative;
  display: inline-block;
}
[data-toggle="collapse"].preview_hs_en:not(.collapsed) .text::after {
  content:'Show less'
}



[data-toggle="collapse"].preview_hs_fr .text::after {
    visibility: visible;
    position: absolute;
    width: 100%;
    left: 0;
    content: 'Voir plus'
}
[data-toggle="collapse"].preview_hs_fr .text {
  visibility: hidden;
  width: 100%;
  position: relative;
  display: inline-block;
}
[data-toggle="collapse"].preview_hs_fr:not(.collapsed) .text::after {
  content:'Voir moins'
}

[data-toggle="collapse"].preview_hs_tr .text::after {
    visibility: visible;
    position: absolute;
    width: 100%;
    left: 0;
    content: 'Daha fazla göster'
}
[data-toggle="collapse"].preview_hs_tr .text {
  visibility: hidden;
  width: 100%;
  position: relative;
  display: inline-block;
}
[data-toggle="collapse"].preview_hs_tr:not(.collapsed) .text::after {
  content:'Az göster'
}


[data-toggle="collapse"].preview_hs_hu .text::after {
    visibility: visible;
    position: absolute;
    width: 100%;
    left: 0;
    content: 'Mutasson többet'
}
[data-toggle="collapse"].preview_hs_hu .text {
  visibility: hidden;
  width: 100%;
  position: relative;
  display: inline-block;
}
[data-toggle="collapse"].preview_hs_hu:not(.collapsed) .text::after {
  content:'Kevesebb mutatása'
}


[data-toggle="collapse"].preview_hs_ru .text::after {
    visibility: visible;
    position: absolute;
    width: 100%;
    left: 0;
    content: 'Показать больше'
}
[data-toggle="collapse"].preview_hs_ru .text {
  visibility: hidden;
  width: 100%;
  position: relative;
  display: inline-block;
}
[data-toggle="collapse"].preview_hs_ru:not(.collapsed) .text::after {
  content:'Показать меньше'
}
</style>
